export default {
    order_note: {
        label: "@:checkout_config.order_note.label",
    }
}